/**
 * Botanical ingredients accordion — one open row per section, animated expand/collapse.
 */
(function () {
  const INNER_SELECTOR = '.s-skin-botanical-ingredients__inner';
  const ITEM_SELECTOR = '.s-skin-botanical-ingredients__item';
  const PANEL_SELECTOR = '.s-skin-botanical-ingredients__panel';
  const CLOSING_CLASS = 's-skin-botanical-ingredients__item--closing';
  const PANEL_TRANSITION_MS = 280;

  const prefersReducedMotion = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const waitPanelTransition = (panel) =>
    new Promise((resolve) => {
      const finish = () => {
        panel.removeEventListener('transitionend', onTransitionEnd);
        resolve();
      };

      const onTransitionEnd = (event) => {
        if (event.target !== panel || event.propertyName !== 'grid-template-rows') return;
        finish();
      };

      panel.addEventListener('transitionend', onTransitionEnd);
      window.setTimeout(finish, PANEL_TRANSITION_MS + 50);
    });

  const closeItem = async (item) => {
    if (!item.open) return;

    if (prefersReducedMotion()) {
      item.removeAttribute('open');
      return;
    }

    const panel = item.querySelector(PANEL_SELECTOR);
    if (!panel) {
      item.removeAttribute('open');
      return;
    }

    item.classList.add(CLOSING_CLASS);
    await waitPanelTransition(panel);
    item.classList.remove(CLOSING_CLASS);
    item.removeAttribute('open');
  };

  const openItem = (item) => {
    item.setAttribute('open', '');
  };

  const ensureSingleOpen = (inner) => {
    const items = [...inner.querySelectorAll(ITEM_SELECTOR)];
    if (!items.length) return;

    const openItems = items.filter((item) => item.open);
    if (openItems.length > 1) {
      for (const item of openItems.slice(1)) {
        item.removeAttribute('open');
      }
    }
  };

  const bindAccordion = (inner) => {
    if (inner.dataset.skinBotanicalAccordionBound === 'true') return;
    inner.dataset.skinBotanicalAccordionBound = 'true';

    const items = [...inner.querySelectorAll(ITEM_SELECTOR)];
    if (!items.length) return;

    ensureSingleOpen(inner);

    for (const item of items) {
      const summary = item.querySelector('summary');
      if (!summary) continue;

      summary.addEventListener('click', async (event) => {
        const willOpen = !item.open;

        if (willOpen) {
          const openOthers = items.filter((other) => other !== item && other.open);
          if (!openOthers.length) return;

          event.preventDefault();
          for (const other of openOthers) {
            await closeItem(other);
          }
          openItem(item);
          return;
        }

        event.preventDefault();
        await closeItem(item);
      });
    }
  };

  const init = (root = document) => {
    for (const inner of root.querySelectorAll(INNER_SELECTOR)) {
      bindAccordion(inner);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
